import { render } from "./ollaHead.vue?vue&type=template&id=0b7286ea&scoped=true"
import script from "./ollaHead.vue?vue&type=script&lang=js"
export * from "./ollaHead.vue?vue&type=script&lang=js"

import "./ollaHead.vue?vue&type=style&index=0&id=0b7286ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7286ea"]])

export default __exports__